import { render, staticRenderFns } from "./ManageRoot.vue?vue&type=template&id=1e847577"
import script from "./ManageRoot.vue?vue&type=script&lang=js"
export * from "./ManageRoot.vue?vue&type=script&lang=js"
import style0 from "./ManageRoot.vue?vue&type=style&index=0&id=1e847577&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports